// extracted by mini-css-extract-plugin
module.exports = {"container":"Full_container__3kl1q"};